import { render, staticRenderFns } from "./InventorySupplementalCostComponent.vue?vue&type=template&id=a274c662&scoped=true"
import script from "./InventorySupplementalCostComponent.vue?vue&type=script&lang=js"
export * from "./InventorySupplementalCostComponent.vue?vue&type=script&lang=js"
import "./InventorySupplementalCostComponent.vue?vue&type=style&index=0&id=a274c662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a274c662",
  null
  
)

export default component.exports